import "./Loader.less";
import * as React from "react";

export class Loader extends React.Component<{}, {}> {
    public render() {
        return (
            <div className="loader"></div>
        );
    }
}